import React, { useState } from "react";
import { SectionTitle } from "@/components/SectionTitle";
import { Trophy, Basketball } from "@phosphor-icons/react";
import { MVPRace } from "@/components/home/MVPRace";
import { PlayerOfGame } from "@/components/PlayerOfGame";

export default function PlayerOfWeek() {
  const [awardTab, setAwardTab] = useState("potg");

  const AWARD_TABS = [
    { k: "potg", label: "Player of the Game", icon: Trophy },
    { k: "mvp", label: "MVP Race", icon: Basketball },
  ];

  return (
    <div className="min-h-screen" data-testid="awards-page">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <SectionTitle kicker="Award Winners" title="Awards" />

        <div className="flex gap-2 flex-wrap my-8" data-testid="award-tabs">
          {AWARD_TABS.map((t) => (
            <button key={t.k} onClick={() => setAwardTab(t.k)} data-testid={`award-tab-${t.k}`}
              className={`px-5 py-2.5 text-sm font-bold uppercase tracking-wide flex items-center gap-2 transition-all ${awardTab === t.k ? "bg-[#FF5722] text-black" : "border border-white/15 text-white/60 hover:text-white"}`}>
              <t.icon size={16} weight={awardTab === t.k ? "fill" : "regular"} /> {t.label}
            </button>
          ))}
        </div>

        {awardTab === "potg" && <PlayerOfGame />}
        {awardTab === "mvp" && <MVPRace limit={15} />}
      </div>
    </div>
  );
}
